import {persistReducer} from "redux-persist";
import storage from "redux-persist/lib/storage";
import {put, takeLatest} from "redux-saga/effects";
import {getUser} from "./authCrud";

export const actionTypes = {
    Login: "[Login] Action",
    Logout: "[Logout] Action",
    LogoutRequest: "[Request Logout] Action",
    UserRequested: "[Request User] Action",
    UserLoaded: "[Load User] Auth API",
    SetUser: "[Set User] Action",
    RefreshToken: "[Refresh Token] Action",
    GetProfile: "[Get Profile] Action",
};

const initialAuthState = {
    token: undefined,
    refreshToken: undefined,
    user: {name: "", surname: ""},
};

export const reducer = persistReducer(
    {
        storage,
        key: "Agent",
        whitelist: ["token", "refreshToken", "user"],
    },
    (state = initialAuthState, action) => {
        switch (action.type) {
            case actionTypes.Login: {
                const {token, refreshToken} = action.payload;
                return {
                    ...state,
                    token,
                    refreshToken,
                };
            }

            case actionTypes.Logout: {
                return initialAuthState;
            }

            case actionTypes.UserLoaded: {
                const {user} = action.payload;
                return {
                    ...state,
                    user: {
                        ...user, number: +user.number
                    }
                };
            }

            case actionTypes.SetUser: {
                const {user} = action.payload;
                return {...state, user};
            }

            case actionTypes.RefreshToken: {
                const {token, refreshToken} = action.payload;

                return {
                    token,
                    refreshToken,
                    user: {
                        ...state.user,
                        token,
                        refreshToken,
                    },
                };
            }

            default:
                return state;
        }
    }
);

export const actions = {
    login: (token, refreshToken) => ({
        type: actionTypes.Login,
        payload: {token, refreshToken},
    }),
    logout: () => ({
        type: actionTypes.Logout,
    }),

    requestUser: () => ({
        type: actionTypes.UserRequested,
    }),
    fulfillUser: (user) => ({
        type: actionTypes.UserLoaded,
        payload: {user},
    }),
    setUser: (user) => ({type: actionTypes.SetUser, payload: {user}}),
    setRefreshToken: (token, refreshToken) => ({
        type: actionTypes.RefreshToken,
        payload: {token, refreshToken},
    }),
    getProfile: () => ({
        type: actionTypes.GetProfile,
    }),
};

export function* saga() {
    yield takeLatest(actionTypes.GetProfile, function* () {
        try {
            const {data} = yield getUser();
            yield put(actions.fulfillUser(data));
        } catch (err) {

        }
    });
}
